module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_3009.fae21d60.png";